export enum localesEnum {
  "pt-BR" = "pt_br",
  "en-US" = "en_us",
}
